export default __webpack_public_path__ + "static/media/Comptia_logo.9ee1392e.png";